module.exports = {"TXTCLI_Current_Balance":{"id":"TXTCLI_Current_Balance","defaultMessage":"Current Balance","flags":["TRACK"],"track":"Current Balance"}}